import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { cleanProps } from '../../utilities/props';
import { ProjectScopeContainer } from '../../components/ProjectScope/ProjectScopeNew.js';
import { ProjectScopePageFooterContainer } from '../../components/ProjectScope/ProjectScopeNew.js';
import NewScopeCategory from '../../components/NewScope/newScopeCategory.js';
import NewScopeSortableItems from '../../components/NewScope/newScopeSortableItems.js';
import NewScopeAsideSubscriptionButtons from '../../components/NewScope/NewScopeAsideSubscriptionButtons.js';
export default function () {
    function mergeProps(inline, external) {
        var res = _.assign({}, inline, external);
        if (inline.hasOwnProperty('style')) {
            res.style = _.defaults(res.style, inline.style);
        }
        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
            res.className = external.className + ' ' + inline.className;
        }
        return res;
    }
    function onClick2(qtFiteredCategories, qtCategoriesReceived, wizardListReceived, wizardList, isWizardMode) {
        this.addNewCategory();
    }
    function onChange3(qtFiteredCategories, qtCategoriesReceived, wizardListReceived, wizardList, isWizardMode, e) {
        this.handleSearchInputChange(e.target.value);
    }
    function repeatQtCategory4(qtFiteredCategories, qtCategoriesReceived, wizardListReceived, wizardList, isWizardMode, qtCategory, qtCategoryIndex) {
        return [React.createElement(NewScopeCategory, {
                'qtCategory': qtCategory,
                'qtCategoryIndex': qtCategoryIndex,
                'key': '21091'
            })];
    }
    function repeatWizardItem5(qtFiteredCategories, qtCategoriesReceived, wizardListReceived, wizardList, isWizardMode, wizardItem, wizardItemIndex) {
        return [React.createElement(NewScopeWizardItem, {
                'wizardItem': wizardItem,
                'wizardItemIndex': wizardItemIndex,
                'key': '23621'
            })];
    }
    function scopeQtFiteredCategoriesQtCategoriesReceivedWizardListReceivedWizardListIsWizardMode6() {
        var qtFiteredCategories = qtFiteredCategories;
        var qtCategoriesReceived = this.props.qtCategoriesReceived;
        var wizardListReceived = this.props.wizardListReceived;
        var wizardList = this.props.wizardList;
        var isWizardMode = this.props.isWizardMode;
        return React.createElement('div', mergeProps({ 'className': 'app-content-wrapper2' }, _.assign({}, cleanProps(this.props))), React.createElement('div', { 'className': 'app-content-main' }, React.createElement('aside', { 'className': 'assign-sidebar' }, React.createElement(NewScopeAsideSubscriptionButtons, { 'setCategoriesVisualizer': this.setCategoriesVisualizer.bind(this) }), !isWizardMode ? React.createElement('div', {
            'className': 'assign-sidebar-add',
            'key': '1336'
        }, React.createElement('button', {
            'className': 'ui-button--add2 ui-button',
            'onClick': onClick2.bind(this, qtFiteredCategories, qtCategoriesReceived, wizardListReceived, wizardList, isWizardMode)
        }, React.createElement('span', { 'className': 'ui-button-icon ui-button-icon--add2' }), React.createElement('span', { 'className': 'ui-button-text' }, 'Add New Category'))) : null, !isWizardMode ? React.createElement('div', {
            'className': 'assign-sidebar-search',
            'key': '1719'
        }, React.createElement('input', {
            'type': 'text',
            'className': 'ui-input ui-input--gray3',
            'placeholder': 'Search',
            'value': this.props.groupsTerm,
            'onChange': onChange3.bind(this, qtFiteredCategories, qtCategoriesReceived, wizardListReceived, wizardList, isWizardMode)
        })) : null, this.state.searchValue ? [React.createElement.apply(this, [
                'ul',
                {
                    'className': 'assign-sidebar-list assign-sidebar-list--qt',
                    'key': '19881'
                },
                !isWizardMode ? _.map(this.state.qtFiteredCategories, repeatQtCategory4.bind(this, qtFiteredCategories, qtCategoriesReceived, wizardListReceived, wizardList, isWizardMode)) : null,
                isWizardMode ? _.map(this.state.wizardListFiltered, repeatWizardItem5.bind(this, qtFiteredCategories, qtCategoriesReceived, wizardListReceived, wizardList, isWizardMode)) : null
            ])] : null, !qtCategoriesReceived || isWizardMode && !wizardListReceived ? React.createElement('div', {
            'style': { height: '200px' },
            'key': '2647'
        }, React.createElement('div', { 'className': 'ui-loader' })) : null, !this.state.searchValue && !(!qtCategoriesReceived || isWizardMode && !wizardListReceived) ? [React.createElement(NewScopeSortableItems, {
                'isWizardMode': isWizardMode,
                'wizardList': wizardList,
                'qtCategories': this.props.qtCategories,
                'onSortEnd': this.onSortEnd.bind(this),
                'shouldCancelStart': this.shouldCancelStart.bind(this),
                'key': '28201'
            })] : null), React.createElement('div', { 'className': 'assign-container' + (this.props.pendingChanges.length > 0 || this.props.hasPendingFeatureChanges ? ' assign-container--pending' : '') }, React.createElement(ProjectScopeContainer, {
            'qtCategories': this.props.qtCategories,
            'newScope': true
        }), this.props.pendingChanges.length > 0 || this.props.hasPendingFeatureChanges ? React.createElement(ProjectScopePageFooterContainer, { 'key': '3510' }) : null)));
    }
    return scopeQtFiteredCategoriesQtCategoriesReceivedWizardListReceivedWizardListIsWizardMode6.apply(this, []);
}